export function formatRand(n) {
  const v = Number(n || 0)
  const safe = Number.isFinite(v) ? v : 0
  return `R${safe.toFixed(2)}`
}

export function parseStoredDate(value) {
  if (!value) return null
  if (typeof value.toDate === 'function') {
    const d = value.toDate()
    return Number.isNaN(d.getTime()) ? null : d
  }
  if (typeof value.seconds === 'number') {
    const d = new Date(value.seconds * 1000)
    return Number.isNaN(d.getTime()) ? null : d
  }
  const d = new Date(value)
  return Number.isNaN(d.getTime()) ? null : d
}

export function getVoucherLoyalty(customer, program) {
  const p = program && typeof program === 'object' ? program : {}
  const threshold = Math.max(0, Number(p.spendThreshold || 900))
  const rewardAmount = Math.max(0, Number(p.rewardAmount || 100))
  const progress = Math.max(0, Number(customer?.voucherSpendProgress || 0))
  const balance = Math.max(0, Number(customer?.voucherBalance || 0))
  const issued = Math.max(0, Number(customer?.vouchersIssuedCount || 0))
  const remaining = Math.max(0, threshold - progress)
  const pct = threshold > 0 ? Math.min(100, Math.round((progress / threshold) * 100)) : 0

  return {
    threshold,
    rewardAmount,
    progress,
    balance,
    issued,
    remaining,
    pct,
    progressLabel: `${formatRand(progress)} / ${formatRand(threshold)}`,
    hasVoucher: balance > 0 || issued > 0,
    isEarning: progress > 0,
  }
}
